import { types } from "../types/types";
const intitalState = {
    contacts: [],
    contactDetails: {},
};

const contactsReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CONTACTS:
            return {
                ...state,
                contacts: action.payload,
            };
        case types.CONTACT_DETAILS:
            return {
                ...state,
                contactDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default contactsReducer;
